import { useRecoilValue } from 'recoil';

import { formatDate, formatTime } from 'lib/helpers/utility';

import useUserPreferencesState from 'components/practice/UserPreferences/hooks/useUserPreferencesState';
import { currentPractice } from 'components/practice/practiceState';

const useDateTimeFormat = () => {
  const practice = useRecoilValue(currentPractice);

  const { generalPreferences } = useUserPreferencesState(['user_general']);
  const dateFormat = generalPreferences?.dateFormat || 'MM/DD/YYYY';
  const timeFormat = generalPreferences?.timeFormat || 'HH:mm';

  return {
    formatDate: (date) => formatDate(date, practice?.timezone, true, dateFormat),
    formatTime: (date) => formatTime(date, practice?.timezone, timeFormat)
  };
};

export default useDateTimeFormat;
